import { Slot } from "@radix-ui/react-slot"
import { twMerge } from "tailwind-merge"
import { MiscIcon } from "./icons/MiscIcon"

export interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	asChild?: boolean
	isLoading?: boolean
}

export function Button({
	asChild,
	className,
	isLoading,
	disabled,
	children,
	...props
}: ButtonProps) {
	const Comp = asChild ? Slot : "button"
	const isDisabled = disabled || isLoading

	return (
		<Comp
			type="button"
			disabled={isDisabled}
			{...props}
			className={twMerge(
				"flex items-center justify-center px-4 h-12 rounded-sm text-foreground bg-button-background border border-button-border disabled:cursor-not-allowed disabled:opacity-50",
				className,
			)}
		>
			{isLoading ? <LoadingState /> : children}
		</Comp>
	)
}

function LoadingState() {
	return (
		<div className="flex items-center justify-center h-[1lh]">
			<MiscIcon className="animate-spin" />
		</div>
	)
}
